<template>
  <div class="business-intro-container">
    <div class="row">
      <div
        class="block"
        style="width: 100%;"
      >
        <h3
          class="bold"
          v-html="title"
        />
        <div v-html="content" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BusinessIntro',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>

.business-intro-container {
  margin: auto;
  padding: 0 10px 30px;
  width: 100%;

  @include teq-breakpoint($medium) {
    max-width: calc(100% - 186px);
    padding: 0 0 30px;
  }
}

.row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 0 20px;
  width: 100%;

  @include teq-breakpoint($medium) {
    align-items: stretch;
    flex-direction: row;
  }
}

.block {
  background: $c-alabaster;
  margin: 0 0 20px;
  padding: 35px;

  @include font-size(16px);

  @include teq-breakpoint($medium) {
    margin: 0;
    width: calc(50% - 10px);
  }
}

</style>
